<app-nav-menu></app-nav-menu>
<p-toast></p-toast>
<p-confirmDialog [closable]="false">
  <ng-template pTemplate="message" let-message>
    <div class="flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border">
      <i class="pi pi-exclamation-circle text-6xl text-primary-500"></i>
      <p>{{ message.message }}</p>
    </div>
  </ng-template>
</p-confirmDialog>

@if (loader) {
  <div style="width: 100%; height: 105vh; position: fixed; background: #e8e8e8de; z-index: 500;top:0 ">
    <div class="text-center" style="width: 100%; display: flex; justify-content: center; align-items: center; text-align: center; height: 100%; }">
      <div class="spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
}
<div style="width:100%;display:flex;">
  <div style="width: 100%; display: flex; padding: 8px; ">
    <div style="width:30%;padding:8px">
      <div class="flight-card" style="margin-bottom: 8px; width: 100%; max-width: 100% !important;padding:7px;display:flex;flex-direction:column">
        <div style="display: flex;   font-size: 14px; width: 100%;flex-direction:column">
          <div style="font-weight:bold;padding:5px">Status:<span style="padding-left:4px;color:var(--first-color-second)">{{offlineObj.bookingStatusName}}</span> </div>
          <div style="font-weight: bold; padding: 5px">Requesting Agency:<span style="padding-left: 4px; color: var(--first-color-second)"> {{offlineObj.requestingAgency}}</span></div>
          <div style="font-weight: bold; padding: 5px">Requester Name:<span style="padding-left: 4px; color: var(--first-color-second)">{{offlineObj.requestingUserName}}</span> </div>
          <div style="font-weight: bold; padding: 5px">Booking Id: <span style="padding-left: 4px; color: var(--first-color-second)">{{offlineObj.offlineId}}</span></div>


        </div>
        <div style="width: 100%;">
          <!--<span *ngIf="request == 'Agent'" style="padding: 10px; font-weight: bold; display: flex; width: 100%; justify-content: center; padding-top: 0px ">Status Booking</span>-->
          <div style="display: flex; width: 100%; justify-content: center; gap: 5px">
            <!--<button class="button-42" *ngIf="request == 'Agent'" (click)="editProfileOpen(3)">Ticketed</button>-->
            @if (request == 'Agent') {
              <button class="button-42" (click)="UpdateOfflineRequest(5)">Invoiced</button>
            }
            @if (request == 'Agent') {
              <button class="button-42" (click)="UpdateOfflineRequest(6)">Removed From List</button>
            }
            @if (request == 'Agent') {
              <button class="button-42" (click)="UpdateOfflineRequest(7)">Refunded</button>
            }
            <button class="button-42" style="background:white;color:orangered" (click)="CheckROUTE()">Back To List</button>
          </div>
        </div>
      </div>
      <div style=" width: 100%;">
        <div class="flight-card">
          <div class="row m-0">
            <div class="mb-2" style="display: flex; width: 100%; background-color: #d64161; justify-content: center; align-items: center; border-radius: 5px; padding: 4px">
              <span style="color:white;font-size:15px">Offline Refund</span>
            </div>
            <div class="col-md-6 p-0">

              <div class="departure-container">
                <div class="departure-label">Booking Details</div>
              </div>
            </div>
            <div class="col-md-6 p-0" style=" justify-content: end; display: flex;">

              <button class="button-10" (click)="viewProfileOpen()"><i></i>View Details</button>
            </div>
          </div>


          <div class="row m-0 p-0">
            <div class="col-md-4 p-0">
              <div style="display:flex;flex-direction:column">
                <div>
                  <span style="font-weight:bold;font-size:12px;color:#ffaa00">Booking Source</span>
                </div>
                <div style="font-size:11px">
                  {{offlineObj.bookingSource}}
                </div>
              </div>
            </div>
            <div class="col-md-4 p-0">
              <div style="display:flex;flex-direction:column">
                <div>
                  <span style="font-weight:bold;font-size:12px;color:#ffaa00">PNR</span>
                </div>
                <div style="font-size:11px">
                  {{offlineObj.pnr}}
                </div>
              </div>
            </div>
            <div class="col-md-4 p-0">
              <div style="display:flex;flex-direction:column">
                <div>
                  <span style="font-weight:bold;font-size:12px;color:#ffaa00">Refund Type</span>
                </div>
                <div style="font-size:11px">
                  {{offlineObj.refundType}}
                </div>
              </div>


            </div>


          </div>
          <div class="row m-0 p-0">
            <div class="mb-1" style="display:flex;width:100%;background-color:#ffaa00;justify-content:center;align-items:center;border-radius:5px;padding:4px">
              <span style="color:white;font-size:15px">Travel Information</span>
            </div>

            <table class="table">
              <thead>
                <tr>

                  <th scope="col">Ticket No</th>
                </tr>
              </thead>
              <tbody>
                @for (passenger of offlineObj.passengerList; track passenger; let u = $index) {
                  <tr>
                    <td>{{passenger.ticketNo}}</td>
                  </tr>
                }

              </tbody>
            </table>

          </div>

        </div>

      </div>

    </div>
    <div style="width:70%;position:relative">
      @if (offlineObj.currentBookingStatus > 0) {
        <div style="max-height:80vh !important;height:80vh">
          <app-chat (dataToParent)="handleData($event)" [GettingUniqueData]="basicDataforChat"></app-chat>
        </div>
      }
    </div>


  </div>
</div>


<p-dialog header="View Details" [(visible)]="viewprofile" [modal]="true"
  [style]="{width: '50vw'}" [draggable]="false" [resizable]="false">

  <form>
    <div class="row m-0 pt-2">
      <!-- Booking Source -->
      <div class="col-md-6 mb-4 p-0 pl-2" style="position: relative;">
        <p-select class="segmentDropdown" [options]="offlineBookingSource" disabled
          name="bookingSource" [(ngModel)]="offlineObj.bookingSource"
          [ngClass]="{'p-dropdown invalid_Prime_Error': bookingSource.invalid && bookingSource.touched}"
          placeholder="Select" optionLabel="offlineSourceName" optionValue="offlineSourceName">
        </p-select>
        <label id="Supplierlabel" [ngClass]="bookingSource.invalid && bookingSource.touched ? 'labelofmodifyserachinputsError' : 'labelofmodifyserachinputs'">
          Booking Source
        </label>
        @if (bookingSource.invalid && bookingSource.touched) {
          <span class="inputErrors">
            ** Booking Source Required!
          </span>
        }
      </div>



      <!-- PNR -->
      <div class="col-md-6 mb-4 p-0 pl-2" style="position: relative;">
        <label [ngClass]="pnr.invalid && pnr.touched ? 'labelofmodifyserachinputsError' : 'labelofmodifyserachinputs'">PNR</label>
        <input type="text" [(ngModel)]="offlineObj.pnr" name="pnr" #pnr="ngModel" required (input)="offlineObj.pnr = offlineObj.pnr.toUpperCase()"
          disabled class="inputStyle"
          [ngClass]="{'invalid-Error': pnr.invalid && pnr.touched}" autocomplete="off" />
          @if (pnr.invalid && pnr.touched) {
            <span class="inputErrors">
              ** PNR Required!
            </span>
          }
        </div>

        <div class="col-md-6  mb-4 p-0 pl-2" style="position: relative;">
          <label id="RoeRateByDefaultlabel" [ngClass]="formsubmission && !offlineObj.refundType?'labelofmodifyserachinputsError':'labelofmodifyserachinputs'">
            Refund Type
          </label>
          <select type="text" [(ngModel)]="offlineObj.refundType" disabled class="inputStyle" required autocomplete="off" [ngClass]="{'invalid-Error': formsubmission && !offlineObj.refundType}"
            name="passtype">

            <option>
              Full
            </option>
            <option>
              Partial
            </option>

          </select>

          @if (formsubmission && !offlineObj.refundType) {
            <span class=" inputErrors">
              **Refund Type  Required!
            </span>
          }

        </div>

        <!-- Remarks -->
        <div class="col-md-12 col-sm-12 mb-4 p-0 pl-2">
          <label>Remarks</label>
          <input type="text" [(ngModel)]="offlineObj.remarks" disabled name="remarks" class="inputStyle" />
        </div>
      </div>
      @if (offlineObj.passengerList!= null &&  offlineObj.passengerList.length>0) {
        <div>
          <div class="row m-0">
            <div class="col-md-6">
              <span>Travel Information</span>
            </div>
            <div class="col-md-6 justify-content-end">
              <!--<button type="button" *ngIf="!submithide" (click)="addPassenger()" class="button-24">Add New</button>-->
            </div>
          </div>
          @for (passenger of offlineObj.passengerList; track passenger; let p = $index) {
            <div>
              <div class="row m-0 pt-2">
                <div class="col-md-12 mb-4 p-0 pl-2">
                  <span>Passenger-{{p+1}}</span>
                  <!--<i class="pi pi-trash text-danger mt-2" *ngIf="p > 0 && !submithide" (click)="removePassenger(p)" style="cursor:pointer"></i>-->
                </div>
                <!-- Ticket No -->
                <div class="col-md-6 mb-4 p-0 pl-2" style="position: relative;">
                  <label id="tktno{{p}}" [ngClass]="tktno.invalid && tktno.touched ? 'labelofmodifyserachinputsError' : 'labelofmodifyserachinputs'">Ticket No</label>
                  <input type="text" [(ngModel)]="passenger.ticketNo" name="tktno{{p}}" #tktno="ngModel" required
                    disabled class="inputStyle" id="tktno{{p}}"
                    [ngClass]="{'invalid-Error': tktno.invalid && tktno.touched}" autocomplete="off" />
                    @if (tktno.invalid && tktno.touched) {
                      <span class="inputErrors">
                        ** Ticket No Required!
                      </span>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        }




        <!-- Submit Button -->
        @if (!submithide) {
          <div class="row m-0">
            <div class="col-md-12 p-0">
              <!--<button type="submit" class="button-9" [disabled]="offlineTicketForm.invalid">Submit</button>-->
            </div>
          </div>
        }
      </form>

    </p-dialog>

    <p-dialog header="Offline Refund" [(visible)]="ticketProfile" [modal]="true"
      [style]="{width: '50vw'}" [draggable]="false" [resizable]="false" [closable]="forrequest">

      <form #offlineTicketForm="ngForm" (ngSubmit)="OtherRequestCreateUpdate()">
        <div class="row m-0 pt-2">
          <!-- Booking Source -->
          <div class="col-md-6 mb-4 p-0 pl-2" style="position: relative;">
            <p-select class="segmentDropdown" [options]="offlineBookingSource" [disabled]="isFormDisabled || (type != 'Create' && request == 'User')"
              name="bookingSource" [(ngModel)]="offlineObj.bookingSource" #bookingSource="ngModel" required
              [ngClass]="{'p-dropdown invalid_Prime_Error': bookingSource.invalid && bookingSource.touched}"
              placeholder="Select" optionLabel="offlineSourceName" optionValue="offlineSourceName">
            </p-select>
            <label id="Supplierlabel" [ngClass]="bookingSource.invalid && bookingSource.touched ? 'labelofmodifyserachinputsError' : 'labelofmodifyserachinputs'">
              Booking Source
            </label>
            @if (bookingSource.invalid && bookingSource.touched) {
              <span class="inputErrors">
                ** Booking Source Required!
              </span>
            }
          </div>



          <!-- PNR -->
          <div class="col-md-6 mb-4 p-0 pl-2" style="position: relative;">
            <label [ngClass]="pnr.invalid && pnr.touched ? 'labelofmodifyserachinputsError' : 'labelofmodifyserachinputs'">PNR</label>
            <input type="text" [(ngModel)]="offlineObj.pnr" name="pnr" #pnr="ngModel" required (input)="offlineObj.pnr = offlineObj.pnr.toUpperCase()"
              [disabled]="request == 'Agent' || isFormDisabled || (type != 'Create' && request == 'User')" class="inputStyle"
              [ngClass]="{'invalid-Error': pnr.invalid && pnr.touched}" autocomplete="off" />
              @if (pnr.invalid && pnr.touched) {
                <span class="inputErrors">
                  ** PNR Required!
                </span>
              }
            </div>

            <!-- Issuing Airline -->

            <div class="col-md-6  mb-4 p-0 pl-2" style="position: relative;">
              <label id="RoeRateByDefaultlabel" [ngClass]="formsubmission && !offlineObj.refundType?'labelofmodifyserachinputsError':'labelofmodifyserachinputs'">
                Refund Type
              </label>
              <select type="text" [(ngModel)]="offlineObj.refundType" [disabled]=" request == 'Agent' || isFormDisabled|| type == 'View'" class="inputStyle" required autocomplete="off" [ngClass]="{'invalid-Error': formsubmission && !offlineObj.refundType}"
                name="passtype">

                <option>
                  Full
                </option>
                <option>
                  Partial
                </option>

              </select>

              @if (formsubmission && !offlineObj.refundType) {
                <span class=" inputErrors">
                  **Refund Type  Required!
                </span>
              }

            </div>
            <!-- Remarks -->
            <div class="col-md-12 col-sm-12 mb-4 p-0 pl-2">
              <label>Remarks</label>
              <input type="text" [(ngModel)]="offlineObj.remarks" [disabled]="isFormDisabled" name="remarks" class="inputStyle" />
            </div>
          </div>
          <div>
            <div class="row m-0">
              <div class="col-md-6 p-0">
                <span>Travel Information</span>
              </div>
              <div class="col-md-6 p-0 justify-content-end" style="display:flex">
                @if (!submithide) {
                  <button type="button" (click)="addPassenger()" class="button-24">Add New</button>
                }
              </div>
            </div>

            @for (passenger of offlineObj.passengerList; track passenger; let p = $index) {
              <div>
                <div class="row m-0 pt-2">
                  <div class="col-md-12 mb-4 p-0 pl-2">
                    <div class="row m-0">
                      <div class="col-md-6 p-0">
                        <span>Passenger-{{p+1}}</span>
                      </div>
                      <div class="col-md-6 p-0 justify-content-end" style="display:flex">
                        @if (p > 0 && !submithide) {
                          <i class="pi pi-trash text-danger mt-2" (click)="removePassenger(p)" style="cursor:pointer"></i>
                        }
                      </div>
                    </div>
                  </div>
                  <!-- Ticket No -->
                  <div class="col-md-6 mb-4 p-0 pl-2" style="position: relative;">
                    <label id="tktno{{p}}" [ngClass]="tktno.invalid && tktno.touched ? 'labelofmodifyserachinputsError' : 'labelofmodifyserachinputs'">Ticket No</label>
                    <input type="text" [(ngModel)]="passenger.ticketNo" name="tktno{{p}}" #tktno="ngModel" required
                      [disabled]="request == 'Agent' || isFormDisabled" class="inputStyle" id="tktno{{p}}"
                      [ngClass]="{'invalid-Error': tktno.invalid && tktno.touched}" autocomplete="off" />
                      @if (tktno.invalid && tktno.touched) {
                        <span class="inputErrors">
                          ** Ticket No Required!
                        </span>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>




            <!-- Submit Button -->
            @if (!submithide) {
              <div class="row m-0">
                <div class="col-md-12 p-0 flex">
                  <div style="width:100%;display:flex;gap:4px;justify-content:end">
                    <button style="width:15%;" type="submit" class="button-9" [disabled]="offlineTicketForm.invalid">Submit</button>
                    <button style="width:15%;" type="button" class="button-cancel" (click)="closeprofile()">Cancel</button>
                  </div>
                </div>
              </div>
            }
          </form>

        </p-dialog>
